import { Flex } from "PFComponents/containers";
import { Id } from "PFTypes";

import { getSortedFiltersArray } from "../../helpers/get_sorted_filters_array";
import { FiltersListProps } from "../../parts/filters_v2_list";
import { FilterV2WithIdentifierAndUpdater } from "../../stores/filters_v2_store/filters_v2_store.types";
import { FilterV2Element } from "./filter_v2_element";
import css from "./filters_v2_list.module.scss";

type FiltersV2ListUnwrappedProps = FiltersListProps & {
  onUpdate: (filter: FilterV2WithIdentifierAndUpdater) => void;
  searchId?: Id;
};

export const FiltersV2ListUnwrapped = ({ vertical, filters, ...props }: FiltersV2ListUnwrappedProps) => (
  <Flex
    direction={vertical ? "column" : "row"}
    as="ul"
    justifyContent="start"
    alignItems="start"
    gap={null}
    wrap="wrap"
    className={css.list}
  >
    {getSortedFiltersArray(filters).map((filter) => (
      <FilterV2Element filter={filter} key={filter.originalPath} {...props} wide={vertical} />
    ))}
  </Flex>
);
